// Display-only cart countdown. This does not reserve Shopify inventory.
class GmCartCountdown extends HTMLElement {
  static duration = 12 * 60 * 1000;
  static storageKey = 'gia-milano-cart-countdown-v1';
  static deadline = null;

  connectedCallback() {
    if (Number(this.dataset.itemCount) === 0) {
      this.hidden = true;
      GmCartCountdown.deadline = null;
      try { localStorage.removeItem(GmCartCountdown.storageKey); } catch (_) { /* Storage may be unavailable. */ }
      return;
    }

    let saved = GmCartCountdown.deadline;
    try { saved = Number(localStorage.getItem(GmCartCountdown.storageKey)) || saved; } catch (_) { /* Use page memory. */ }
    this.deadline = Number.isFinite(saved) && saved > 0 ? saved : Date.now() + GmCartCountdown.duration;
    GmCartCountdown.deadline = this.deadline;
    try { localStorage.setItem(GmCartCountdown.storageKey, String(this.deadline)); } catch (_) { /* Use page memory. */ }
    this.hidden = false;
    this.renderTime();
    if (this.deadline > Date.now()) this.interval = setInterval(() => this.renderTime(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  renderTime() {
    const now = Date.now();
    if (this.deadline <= now) {
      this.deadline = now + GmCartCountdown.duration;
      GmCartCountdown.deadline = this.deadline;
      try { localStorage.setItem(GmCartCountdown.storageKey, String(this.deadline)); } catch (_) { /* Use page memory. */ }
    }
    const remaining = Math.ceil((this.deadline - now) / 1000);
    const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
    const seconds = String(remaining % 60).padStart(2, '0');
    const output = this.querySelector('[data-countdown]');
    if (output) output.textContent = `${minutes}:${seconds}`;
  }
}

if (!customElements.get('gm-cart-countdown')) customElements.define('gm-cart-countdown', GmCartCountdown);
